var option_webview_default = {
  "option": "komOl",
  "user_choice": "Kqt1H",
  "check": "s3ljX",
  "image": "mninD",
  "input": "I-yoe",
  "title": "yKDvm",
  "centered": "MaqB-",
  "with_result": "Qx4tZ",
  "list": "LOy8R",
  "with_image": "_7tyRl",
  "progress": "R00--",
  "progress_value": "G6VwQ",
  "label": "-L-Kj",
  "cta": "BlJkd",
  "adornment_icon": "-Rw7-",
  "remove": "dKHu0",
  "removeButton": "IUNx1",
  "removeButtonIcon": "A0mXN",
  "overlay": "NZCwp",
  "shown": "RafB2",
  "dark": "rmsiS",
  "spinner": "LqP3R",
  "spin": "IO9bz",
  "grid": "JqUCk"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
